<template>
  <div>
    <el-dialog
      :title="isCreate ? '新增事件' : '编辑事件'"
      center
      :visible="true"
      @close="close"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
    >
      <el-form ref="form" label-width="150px" size="mini">
        <el-form-item label="事件：" prop="event">
          <el-select
            style="width: 140px"
            :disabled="!isCreate"
            v-model="form.event"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in availableEvents"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="接收人：" prop="receivers">
          <el-select
            multiple
            style="width: 340px"
            v-model="form.receivers"
            filterable
            placeholder="请选择"
          >
            <el-option
              v-for="item in availableUsers"
              :key="item"
              :label="item"
              :value="item"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="close">取消</el-button>
        <el-button
          type="primary"
          @click="operation(isCreate ? 'add' : 'edit', form)"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
const axios = require("axios");
const util = require("@/util");
import bizutil from "@/bizutil";
const dialogutil = require("@/dialogutil");

// 本弹窗名称
const DialogName = "EditCorpEventReceiverDialog";

export default {
  data() {
    return {
      isCreate: true,
      form: {
        event: "",
        receivers: [],
      },
      availableUsers: [],
      availableEvents: [],
    };
  },
  components: {},
  async created() {
    await this.loadAvailableUsers();
    await this.loadAvailableEventes();
    let value = dialogutil.getData(DialogName);

    this.isCreate = value.isCreate;
    if (!this.isCreate) {
      this.form = value.entry;
    }
  },

  methods: {
    async loadAvailableEventes() {
      this.availableEvents = await this.$bizutil.loadCorpEvents();
    },
    async loadAvailableUsers() {
      let resData = (
        await axios.post(
          `${util.getBackendApiBase()}/v1/admin/corpflow/queryCorpMember`,
          {},
          {
            headers: {
              token: bizutil.getLoginUserToken(),
            },
          }
        )
      ).data;
      if (resData.code > 0) {
        this.$message.error(resData.message);
        return;
      }

      let listInResponse = resData.data.list || [];
      for (let item of listInResponse) {
        this.availableUsers.push(item.name);
      }
    },

    async operation(op, entry) {
      try {
        switch (op) {
          case "add": {
            // 弹确认框
            await this.$confirm(`确认新增事件：${entry.event}？`);
            break;
          }
          case "edit": {
            // 弹确认框
            await this.$confirm(`确认更新事件：${entry.event}？`);
            break;
          }
          default: {
            this.$message.error("未知操作：" + op);
            return;
          }
        }

        let resData = (
          await axios.post(
            `${util.getBackendApiBase()}/v1/admin/corpflow/operationCorpEventReceiver`,
            {
              operation: op,
              entry: entry,
            },
            {
              headers: {
                token: bizutil.getLoginUserToken(),
              },
            }
          )
        ).data;
        if (resData.code > 0) {
          this.$message.error(resData.message);
          return;
        }

        this.$message({
          message: "操作成功",
          type: "success",
        });

        this.close();
      } catch (e) {}
    },
    close() {
      // 关闭当前对话框
      dialogutil.close(DialogName);
    },
  },
};
</script>